import { FC, useEffect, useRef } from 'react';

import { useParams } from 'react-router-dom';

import useTheme from 'api/useTheme';
import { PREVIEW_CONTAINER_WIDTH } from 'views/OfferDesign/OfferDesign.consts';
import { OfferDesignTypes, RenderCardFn } from 'views/OfferDesign/OfferDesign.types';

import {
  applyCssVariables,
  clearCssVariables,
  renderBundleCard,
  renderProgressBarCard,
  renderPromotionCard
} from './OfferDesignPreview.utils';

const RENDER_MAP: Record<string, RenderCardFn> = {
  [OfferDesignTypes.Bundle]: renderBundleCard,
  [OfferDesignTypes.SpecialOffer]: renderPromotionCard,
  [OfferDesignTypes.ProgressBar]: renderProgressBarCard
};

interface OfferDesignPreviewProps {
  offerType: OfferDesignTypes;
  values: Record<string, any>;
}

export const OfferDesignPreview: FC<OfferDesignPreviewProps> = ({
  offerType,
  values
}) => {
  const containerRef = useRef<HTMLDivElement>(null);
  const { publisherId } = useParams();
  const { getGeneralTheme: generalTheme, getStoreScreen: storeScreen } = useTheme(publisherId);

  useEffect(() => {
    const el = containerRef.current;
    if (!el || !storeScreen.data) return;

    applyCssVariables(el, storeScreen.data, generalTheme.data?.font || '');
    return () => clearCssVariables(el);
  }, [storeScreen.data, generalTheme.data?.font]);

  if (generalTheme.isLoading || storeScreen.isLoading || !generalTheme.data || !storeScreen.data) return null;

  const renderCard = RENDER_MAP[offerType];
  if (!renderCard) return null;

  return (
    <div className="w-1/2 h-full bg-zinc-100 px-16 pt-9 pb-8 overflow-y-auto">
      <div className="flex justify-center items-center min-h-[667px]">
        <div ref={containerRef} style={{ width: PREVIEW_CONTAINER_WIDTH }}>
          {renderCard(values, generalTheme.data, storeScreen.data)}
        </div>
      </div>
    </div>
  );
};
